import { getProcessAttributesByPartialName, getProcessOccurencesDetail, getProcessRelationships } from "../../actions";

// One object's details, for the panel that shows them: its attributes, where
// it occurs and what it is related to.
//
// It always answers. An object the server can't read - one that was imported
// without an id, one that has been removed, a database that is away - answers
// with `error`, so the panel says so in words. It used to leave the panel on
// its loading skeletons for ever, because one failed call rejected the whole
// batch and the state that turns them off was never set.
//
// `occurrencesSearched` is the server's account of how thorough the
// occurrences search was (`searched` from `?detail=1`) - null until it
// answers, so the panel never claims a search was complete before it knows.
export const EMPTY_DETAILS = {
  loading: false,
  attributes: null,
  occurrences: [],
  occurrencesSearched: null,
  relationships: [],
  error: null,
};

const COULD_NOT_READ = "This object's details couldn't be read.";

const list = (value) => (Array.isArray(value) ? value : []);

// `known` is the attributes answer the caller already has in hand - the
// explorer reads them to draw the card it opens on, so the panel that fills
// itself with that same object asks for them a second time for nothing.
// Anything else (a refusal, or nothing at all) is read from the server as usual.
export const loadObjectDetails = async (guid, known = null) => {
  const alreadyRead = known && known.success !== false ? known : null;
  try {
    const [attributes, occurrences, relationships] = await Promise.all([
      alreadyRead || getProcessAttributesByPartialName(guid),
      getProcessOccurencesDetail(guid),
      getProcessRelationships(guid),
    ]);
    // A refusal is an answer, not a set of attributes: the server's own words
    // are what the reader needs to see.
    if (!attributes || attributes.success === false) {
      return { ...EMPTY_DETAILS, error: attributes?.msg || COULD_NOT_READ };
    }
    return {
      loading: false,
      error: null,
      attributes,
      occurrences: list(occurrences?.items),
      occurrencesSearched: occurrences?.searched || null,
      relationships: list(relationships),
    };
  } catch (err) {
    return { ...EMPTY_DETAILS, error: COULD_NOT_READ };
  }
};
